import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FaRegCopy } from 'react-icons/fa';

const Modal = ({ isOpen, videoSrc, onClose }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50"
      onClick={handleBackdropClick}
    >
      <div className="relative bg-white rounded-lg">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          className="absolute top-2 right-2 text-lg text-red-500 bg-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-red-100 transition-colors z-10"
        >
          ×
        </button>
        <video
          src={videoSrc}
          controls
          className="rounded-lg shadow-lg cursor-pointer"
          style={{ height: '400px', width: '600px' }}
        />
      </div>
    </div>
  );
};

const VideosModal = ({ procedure }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const hasVideos = procedure?.videos?.length > 0;

  const openModal = src => {
    setSelectedVideo(src);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedVideo(null);
  };

  const copyToClipboard = text => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success('Copied to clipboard!');
    });
  };

  function splitFilename(filename) {
    const lastDotIndex = filename?.lastIndexOf('.');

    if (lastDotIndex === -1) {
      return { name: filename, extension: '' };
    }

    const name = filename?.substring(0, lastDotIndex);

    return name;
  }

  return (
    <section id="videos" className="mb-12">
      <h2 className="text-2xl font-bold mb-4">Videos</h2>
      {hasVideos ? (
        <div>
          <ul className="list-disc list-inside">
            {procedure.videos.map((item, index) => (
              <li key={index} className="flex items-center space-x-2">
                <a
                  onClick={() => openModal(item.src)}
                  className="cursor-pointer text-blue-500 hover:underline"
                >
                  {splitFilename(item?.name)}
                </a>
                <button
                  onClick={() => copyToClipboard(item?.src)}
                  className="relative group ml-2 text-gray-600 border border-gray-300 rounded p-1 hover:bg-gray-100"
                  aria-label="Copy link"
                  title="Click to copy link"
                >
                  <FaRegCopy />
                </button>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="text-center text-gray-500">No videos available.</p>
      )}
      <Modal isOpen={isOpen} videoSrc={selectedVideo} onClose={closeModal} />
    </section>
  );
};

export default VideosModal;
